import { apiRequest } from './index';

export const usersAPI = {
  getAll: () => apiRequest("/users"),
  getActive: () => apiRequest('/users/active'), 
  getById: (userId) => apiRequest(`/users/${userId}`),

  create: (userData) => 
    apiRequest("/users", {
      method: "POST",
      body: userData,
    }),

  update: (userId, userData) => 
    apiRequest(`/users/${userId}`, {
      method: "PUT",
      body: userData,
    }),

  delete: (userId) => 
    apiRequest(`/users/${userId}`, { method: "DELETE" }),

  getEmployeeOrder: () => apiRequest('/users/me/employee-order'),
  setEmployeeOrder: (order) =>
    apiRequest('/users/me/employee-order', {
      method: 'PUT',
      body: { order }
    })
};
